// export const DATE_FORMAT = "MMM[.] D YYYY [at] h:mm A";
export const DATE_FORMAT = 'MMM D, YYYY'
